import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Image,
} from "react-bootstrap";
import PropTypes from "prop-types";
import { Credentials } from "../../models/Credentials";
import LoginService from "../../services/login.service";
import { Navigate, useNavigate } from "react-router-dom";
import "../../custom.scss";
import { UserInfo } from "../../models/UserInfo";
type Props = {
  setUser: (user: UserInfo) => void;
};

export default function Login(props: Props) {
  const [username, setUserName] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [validated, setValidated] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const validationErrorTitle: string = "Error";
  const validationErrorMessage: string =
    "Debe llenar todos los campos para iniciar sesión";
  const navigate = useNavigate();

  async function handleSubmit(event: any) {
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setErrorTitle(validationErrorTitle);
      setErrorMessage(validationErrorMessage);
      setShowValidationError(true);
      window.scrollTo(0, 0);
      return;
    }

    let credentials: Credentials = { username: username, password: password };
    try {
      const result = LoginService.Login(credentials);

      result
        .then((response) => {
          var resp = response as unknown as Response;

          if (resp.ok) {
            return resp.json();
          } else {
            setErrorMessage("Nombre de usuario o contraseña incorrecta");
            setShowValidationError(true);
            setErrorTitle("Error en inicio de sesión");
          }
        })
        .then((json) => {
          props.setUser(json);
          let questionaryIdStorage = localStorage.getItem("questionaryId");
          let questionaryEmail = localStorage.getItem("questionaryEmail");
          if (
            questionaryIdStorage &&
            (questionaryEmail == json.email || json.role == "Administrador")
          ) {
            navigate("/FillQuestionary");
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      setErrorMessage("Nombre de usuario o contraseña incorrecta");
      setShowValidationError(true);
      setErrorTitle("Error en inicio de sesión");
    }
    event.preventDefault();
  }

  return (
    <Container className="mt-5">
      <Row>
        <Col md={{ span: 6, offset: 3 }}>
          {showValidationError && (
            <div
              aria-live="polite"
              aria-atomic="true"
              className="bg-dark position-relative"
              style={{}}
            >
              <Alert
                variant="danger"
                onClose={() => setShowValidationError(false)}
                dismissible
              >
                <Alert.Heading>{errorTitle}</Alert.Heading>
                <p>{errorMessage}</p>
              </Alert>
            </div>
          )}
          <Card>
            <Card.Body>
              <Row>
                <Col className="text-center">
                  <Image src="logo-legacy.png" fluid />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                  >
                    <Row>
                      <Col>
                        <Form.Group className="mb-3">
                          <Form.Label>Nombre de usuario</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Ingresa el nombre de usuario"
                            required={true}
                            onChange={(e) => setUserName(e.target.value)}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Contraseña</Form.Label>
                          <Form.Control
                            type="password"
                            placeholder="Ingresa la contraseña"
                            required={true}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-center mt-3">
                        <a
                          href="/forgot-password"
                          style={{ cursor: "pointer" }}
                        >
                          ¿Olvidaste tu contraseña?
                        </a>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-center">
                        <Button type="submit" variant="primary">
                          Iniciar Sesión
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

Login.propTypes = {
  setUser: PropTypes.func.isRequired,
};
